const DEMO_HREF = 'https://demo.octopwn.com'

let lastDemoConversion = 0

export function trackDemoConversion(href, wapp) {
    if (!href || href.indexOf(DEMO_HREF) !== 0) {
        return
    }
    const now = Date.now()
    if (now - lastDemoConversion < 500) {
        return
    }
    lastDemoConversion = now
    if (typeof gtag !== 'undefined') {
        gtag('event', 'conversion', {
            'send_to': 'AW-18400842077/G1GJCPv18uQcEN2imsZE',
            'value': 1.0,
            'currency': 'EUR'
        })
        if (wapp && wapp.globals && wapp.globals.DEV) {
            console.log('[GTC] demo conversion sent to gtag', href)
        }
    }
}
